import mapContextToProps from '@restart/context/mapContextToProps';
import React, { useContext } from 'react';
const DialogContext = React.createContext(null);
export default DialogContext;
export function useDialog() {
  return useContext(DialogContext);
}
export function withDialog(Component) {
  return mapContextToProps(DialogContext, dialog => ({
    dialog
  }), Component);
}